import { useAuth } from "../../lib/auth";
import { useIntl } from "../../lib/i18n";

export default function DashboardPage() {
  const { session } = useAuth();
  const { t } = useIntl();
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("dashboard.title")}</h1>
      <p className="mt-2 text-slate-600">{t("dashboard.welcome", { email: session?.email ?? "" })}</p>
      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Card title={t("dashboard.firm")} value={session?.tenantSlug ?? "—"} />
        <Card title={t("dashboard.roles")} value={session?.roles.join(", ") || "—"} />
      </div>
    </div>
  );
}

function Card({ title, value }: { title: string; value: string }) {
  return (
    <div className="rounded-xl bg-white p-5 shadow-sm ring-1 ring-slate-200">
      <div className="text-xs uppercase tracking-wide text-slate-500">{title}</div>
      <div className="mt-1 text-sm text-brand-900">{value}</div>
    </div>
  );
}
